// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pmsIE","colBig":"styles_colBig__3FScT","colSmall":"styles_colSmall__2tOn0","shopifyNameWrapper":"styles_shopifyNameWrapper__1A8yv"};